<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header m-0">
      <div class="md-layout md-alignment-center">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-60 p-0">
          <h4>{{ this.headerData.title + ": " }}</h4>
          <ul>
            <li>
              <p class="sub-title-formatting">
                <i class="md-icon md-icon-dark-blue">business_center</i>Industry: </p>
              <p>
                [{{ parseInt(headerData.bznaics) }}] {{ headerData.industry }} </p>
            </li>
            <li>
              <p class="sub-title-formatting">
                <i class="md-icon md-icon-dark-blue">business</i>Sector: </p>
              <p>{{ this.headerData.sector }}</p>
            </li>
            <li>
              <p class="sub-title-formatting">
                <i class="md-icon md-icon-dark-blue">place</i>Market Area: </p>
              <p>{{ this.headerData.area }}</p>
            </li>
          </ul>
        </div>
        <div class="md-layout-item md-medium-size-100 md-size-40 button-box">
          <md-button class="btn-min-width md-info access-button pdf_btn" @click="feedback">
            <md-icon>comment</md-icon>
            Product Feedback
          </md-button>
          <md-button :class="
              pdfLoading2 || !profile || !profile.years
                ? 'md-info access-button pdf_btn disabled'
                : 'btn-min-width md-info access-button pdf_btn'
            " @click="generateFile2" target="_blank">
            <md-icon class="ml-5">task
            </md-icon>
            {{
              pdfLoading2
                  ? "Downloading"
                  : !profile || !profile.years
                      ? "Loading..."
                      : "Concentration Data"
            }}
          </md-button>
          <md-button :class="
              pdfLoading || !profile || !profile.years
                ? 'md-info access-button pdf_btn disabled'
                : 'btn-min-width md-info access-button pdf_btn'
            " @click="downloadPDFDataAPI" target="_blank">
            <template>
              <md-icon class="ml-5">picture_as_pdf
              </md-icon>
              {{
                pdfLoading || this.pdfGenerating ? "Generating..."
                    : !profile || !profile.years
                        ? "Loading..."
                        : "Download PDF"
              }}
            </template>
          </md-button>
          <md-button :class="
              csvLoading || !profile || !profile.years
                ? 'md-info access-button pdf_btn disabled'
                : 'btn-min-width md-info access-button pdf_btn'
            " @click.native="downloadCSVData">
            <md-icon class="ml-5">receipt_long
            </md-icon>
            {{
              csvLoading
                  ? "Downloading"
                  : !profile || !profile.years
                      ? "Loading..."
                      : "Download CSV"
            }}
          </md-button>
        </div>
      </div>
    </div>
    <modal v-if="feedbackModal" @close="feedbackModal = false" class="feedback_modal">
      <template slot="body">
        <button type="button" class="close_btn" @click="feedbackModal = false">
          <md-icon>clear</md-icon>
        </button>
        <h3 class="modal-title">Have feedback on this product?</h3>
        <p>
          Enter the details below to send your feedback to our Product Team. </p>
        <form action class="form_grp">
          <div class="field_wpr">
            <label>Leave A Feedback Note</label>
            <textarea v-model="textFeedback" placeholder="Type a message"></textarea>
            <md-field>
              <md-select v-model="category" name="category">
                <md-option v-for="(option, key) in optionsCategory" :key="key" :label="option" :value="key">{{ option }}
                </md-option>
              </md-select>
            </md-field>
            <md-button @click="sendFeedback" class="md-info md-round mt-4">Send Feedback
            </md-button>
          </div>
        </form>
      </template>
    </modal>
    <div class="md-layout-item md-size-100" v-if="headerData && user">
      <IMPDF ref="html2Pdf" :headerInfo="{ headerData, user }" :category="category"/>
      <IMRFile2PDF v-if="imrFile2" ref="html2PdfFile2" :headerInfo="{ headerData, user }" :category="category" :imrFile2="this.imrFile2"/>
      <IMRFile2PDFSample ref="html2PdfFile2Sample" :headerInfo="{ headerData, user }"/>
    </div>
  </div>
</template>
<script>
import {Collapse, Modal} from "@/components";
import {mapActions, mapState} from "vuex";
// import VueHtml2pdf from 'vue-html2pdf';
// import PdfDocument from './PdfDocument.vue';
import IMPDF from "./_partials/IMPDF.vue";
import IMRFile2PDF from "./_partials/IMRFile2PDF.vue";
import IMRFile2PDFSample from "./_partials/IMRFile2PDFSample.vue";
import axios from "axios";

export default {
  components: {
    // Collapse,
    Modal,
    // VueHtml2pdf,
    // PdfDocument,
    IMRFile2PDF,
    IMRFile2PDFSample,
    IMPDF,
  },
  props: ["headerData"],
  data() {
    return {
      imrFile2: null,
      optionsCategory: {
        0: "Select a Category",
        1: "1 - Report an Error",
        2: "2 - Suggest an Improvement",
        3: "3 - Request a Correction",
        4: "4 - Request an Update",
      },
      category: 0,
      feedbackModal: false,
      textFeedback: "",
      showDialog: false,
      tableDataMarketEmpVolume: [],
      tableDataPercentMarketVolumeClass: [],
      tableDataAverageSalesClass: [],
      filtered_population: [],
      filtered_market_volume: [],
      filtered_market_share: [],
      filtered_annual_sales: [],
      filtered_penetration: [],
      filtered_employment: [],
      filtered_market_by_class: [],
      filtered_market_percent_by_class: [],
      filtered_average_sale_by_class: [],
      filtered_establishment_by_class: [],
      filtered_total_employment_by_class: [],
      filtered_average_employment_by_class: [],
      filtered_annual_sales_per_employee: [],
      filtered_average_annual_wage: [],
      filtered_rent_per_employee: [],
      filtered_startup_info: [],
      filtered_cessation_info: [],
      filtered_ownership_info: [],
      filtered_demographic_info: [],
      tableDataEstablishments: [],
      tableDataTotalEmployment: [],
      tableDataAverageEmployment: [],
      tableDataSalesPerEmployee: [],
      tableDataAverageAnnualWage: [],
      tableDataRentPerEmployee: [],
      tableDataProductivityIndices: [],
      tableDataStartupPerformance: [],
      tableDataStartupActivityRates: [],
      pdfGenerating: false
    };
  },
  computed: {
    ...mapState({
      profile: (state) => state.user.industryProfile,
      pdfLoading: (state) => state.user.pdfLoading,
      csvLoading: (state) => state.user.csvLoading,
      pdfLoading2: (state) => state.user.pdfLoading2,
      user: (state) => state.user.user,
      locations: (state) =>
          state.user.industryProfile["mapDataVestimate"]
              ? state.user.industryProfile["mapDataVestimate"].filter(
                  (x) => x.lat !== null && x.lng !== null
              )
              : null,
      tableCompetitors: (state) =>
          state.user.industryProfile && state.user.industryProfile.data
              ? state?.user?.industryProfile?.data["competitors"]
              : "",
      marketVolume: (state) =>
          state.user.industryProfile && state.user.industryProfile.data
              ? state.user.industryProfile.data["marketVolume"]
              : "",
      marketShare: (state) =>
          state.user.industryProfile && state.user.industryProfile.data
              ? state.user.industryProfile.data["marketShare"]
              : "",
      years: (state) => state.user.industryProfile.years,
      release_years: (state) =>
          state?.user?.industryProfile?.general?.release_years,
      release_display: (state) =>
          state?.user?.industryProfile?.general?.["release_display"],
      bznaics_code: (state) => state.user?.industryProfile?.general?.bznaics,
      sector_name: (state) => state?.user?.industryProfile?.general?.sector,
      industry_title: (state) => state?.user?.industryProfile?.general?.industry,
      update_month: (state) => state.user.industryProfile.updateMonth,
      display_area: (state) =>
          state?.user?.industryProfile?.general?.area_display_name,
      annualSales: (state) =>
          state.user.industryProfile && state.user.industryProfile.data
              ? state.user.industryProfile.data["annualSales"]
              : "",
      annualSalesCols: (state) => state.user.industryProfile["annualSalesCols"],
      penetration: (state) =>
          state.user.industryProfile.data
              ? state.user.industryProfile.data["penetration"]
              : "",
      employment: (state) =>
          state.user.industryProfile.data
              ? state.user.industryProfile.data["employment"]
              : "",
      salesEmpSales: (state) =>
          state.user.industryProfile.data
              ? state.user.industryProfile.data["salesEmpSales"]
              : "",
      salesEmpCols: (state) => state.user.industryProfile["salesEmpCols"],
      salesEmpEmployment: (state) =>
          state?.user?.industryProfile?.data
              ? state?.user?.industryProfile?.data["salesEmpEmployment"]
              : null,
      productivityValues: (state) =>
          state?.user?.industryProfile?.data
              ? state?.user?.industryProfile?.data["productivityValues"]
              : null,
      productivity: (state) =>
          state?.user?.industryProfile?.data
              ? state.user.industryProfile.data["productivityValues"]
              : null,
      startupPerformance: (state) =>
          state?.user?.industryProfile?.data
              ? state?.user?.industryProfile?.data["startupsValues"]
              : null,
      startupRates: (state) => state.user.industryProfile.data["startupsIndex"],
      cessation: (state) =>
          state?.user?.industryProfile?.data
              ? state.user.industryProfile.data["cessation"]
              : null,
      ownership: (state) =>
          state?.user?.industryProfile?.data
              ? state?.user?.industryProfile?.data["ownership"]
              : null,
      demographics: (state) =>
          state?.user?.industryProfile?.data
              ? state.user.industryProfile.data["demographics"]
              : null,
      startupsValues: (state) =>
          state?.user?.industryProfile?.data
              ? state?.user?.industryProfile?.data["startupsValues"]
              : null,
      startupsIndex: (state) =>
          state.user.industryProfile.data["startupsIndex"],
      chartData: (state) =>
          state.user.industryProfile.charts
              ? state.user.industryProfile.charts.test["Cessation"][0]
              : null,
      cessation_years: (state) => state?.user?.industryProfile?.general?.cessation_years,
    }),
    cessationLabel() {
      return this.cessation_years && this.cessation_years.length === 2
        ? `${this.cessation_years[0]}-${this.cessation_years[1]} Cessation Rates`
        : 'Cessation Rates';
    },
    pdfDownloadSetting() {
      return this.user &&
      this.user.preferences &&
      this.user.preferences.defaultPDFDownload
          ? this.user.preferences.defaultPDFDownload
          : "_blank";
    },
  },
  watch: {
    profile(newVal) {
      if (newVal) this.parseCSVData();
    },
  },
  methods: {
    ...mapActions({
      registerProductExport: "tracking/registerProductExport",
    }),
    async getImrFile2() {
      let currentSession = localStorage.getItem(
          "vue-authenticate.vueauth_access_token"
      );
      await axios
          .post(
              process.env.VUE_APP_API_BASE_URL + "/user/profile/imr-file2",
              {},
              {
                params: {
                  session_id: currentSession,
                  profile_id: this.$route.params.id,
                },
              }
          )
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/report/imr-file2" <br>`
              );
              throw new Error(
                  "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            } else {
              this.imrFile2 = res.data.data;
            }
          });
    },
    async generateFile2() {
      if (this.$route.path.includes("sample"))
        this.$refs.html2PdfFile2Sample.$refs.html2PdfFile2Sample.generatePdf();
      else {
        this.$store.commit("user/SET_PDF_LOADING_2", true);
        await this.getImrFile2();
        await this.$refs.html2PdfFile2.$refs.html2PdfFile2.generatePdf();
        setTimeout(() => {
          this.$store.commit("user/SET_PDF_LOADING_2", false);
        }, 10000);
      }
      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: "PDF",
      });
    },
    async generateReport() {
      this.$store.commit("user/SET_PDF_LOADING", true);
      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: "PDF",
      });
      this.$refs.html2Pdf.$refs.html2Pdf.generatePdf();
      setTimeout(() => {
        this.$store.commit("user/SET_PDF_LOADING", false);
      }, 256000);
    },

    downloadPDFDataAPI() {
      // PDF API download
      this.pdfGenerating = true;

      let data = {};
      data.type = 'imp';
      data.report = this.profile;
      data.cmnText = this.$store.state.user.cmnText;
      this.$store.dispatch('pdf/download', data).then(async (res) => {
        this.pdfGenerating = false;

        if(res.pdf_success) {
          window.open(res.pdf_data, '_blank');
        }
      });
    },

    feedback() {
      this.feedbackModal = true;
    },
    sendFeedback() {
      let parameters = {};
      parameters["name"] = this.headerData.title;
      parameters["Industry"] = this.headerData.industry;
      parameters["Area"] = this.headerData.area;
      parameters["Sector"] = this.headerData.sector;
      parameters = JSON.stringify(parameters);
      if (this.category) {
        let currentSession = localStorage.getItem(
            "vue-authenticate.vueauth_access_token"
        );
        axios
            .post(
                process.env.VUE_APP_API_BASE_URL + "/user/feedback/submit",
                {},
                {
                  params: {
                    session_id: currentSession,
                    feedback: this.textFeedback,
                    url: `${window.location.href}`,
                    category: this.category,
                    parameters: parameters,
                  },
                }
            )
            .then((res) => {
              if (res.hasOwnProperty("data") && res.data.error) {
                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                    "SET_ERROR_INFO",
                    "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
                );
                throw new Error(
                    "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode
                );
              }
              if (res.data.success)
                this.$store.dispatch("alerts/success", "Data saved.");
              else
                this.$store.dispatch(
                    "alerts/error",
                    "An error occured. please try again"
                );
              this.feedbackModal = false;
              this.textFeedback = null;
              this.category = 0;
            });
      } else {
        this.$store.commit("SET_ERROR_BIT", true);
        this.$store.commit(
            "SET_ERROR_INFO",
            "<br>" +
            "Server responded with error = True <br> errorCode: " +
            "category_not_set" +
            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
        );
      }
    },
    getCSVData() {
      let csvData = [
        ["Bizminer Local Industry Market Report"],
        [this.bznaics_code, this.industry_title],
        ["Sector: " + this.sector_name],
        [this.display_area],
        ["Data Time Series", this.years],
        ["Update Month", this.update_month],
        [""],
      ];
      csvData.push(["Industry Population Analyzed"], ["as of:", this.years]);
      this.filtered_population.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push(
          [""],
          ["Annual Industry Market Volume($)"],
          ["as of:", this.years]
      );
      this.filtered_market_volume.forEach((e, i) => {
        e.forEach((k, i) => {
          if (typeof k === "string" && k.includes(".")) {
            e[i] = k.replace(/\./g, "");
          }
        });
        csvData.push(e);
      });
      csvData.push([""], ["Share(%)"], ["", this.years]);
      this.filtered_market_share.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""], [""], ["Average Annual Sales"]);
      csvData.push(["", this.annualSalesCols]);
      this.filtered_annual_sales.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      csvData.push([""], ["Rank"], ["as of:", this.years]);
      csvData.push([""], [""], [""], [""], [""]);
      csvData.push(["Market Penetration ($)"]);
      csvData.push(["", this.years]);
      this.filtered_penetration.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push(
          [""],
          [
            "To enhance report load times Sales per Business Establishment values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser",
          ]
      );
      csvData.push([""], [""]);
      csvData.push(["Employment", this.years]);
      this.filtered_employment.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, "");
        }
        csvData.push(e);
      });
      csvData.push([""], [""]);
      csvData.push(["Market Volume by Employment Class", this.years]);
      this.filtered_market_by_class.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      csvData.push(
          [""],
          ["Percent Market Volume by Employment Class", this.years]
      );
      this.filtered_market_percent_by_class.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      csvData.push([""], ["Average Sales by Employment Class", this.years]);
      this.filtered_average_sale_by_class.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      csvData.push([""], ["Establishments by Employment Class", this.years]);
      this.filtered_establishment_by_class.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      csvData.push([""], ["Total Employment by Class", this.years]);
      this.filtered_total_employment_by_class.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      csvData.push([""], ["Average Employment by Class", this.years]);
      this.filtered_average_employment_by_class.forEach((e, i) => {
        if (typeof e === "string" && e.includes(",")) {
          e = e.replace(/,/g, ".");
        }
        csvData.push(e);
      });
      csvData.push([""], ["Productivity"]);
      csvData.push(["Annual Sales per Employee", this.years]);
      this.filtered_annual_sales_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], [""]);
      csvData.push(["Average Annual Wage", this.years]);
      this.filtered_average_annual_wage.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], [""]);
      csvData.push(["Rent per Employee", this.years]);
      this.filtered_rent_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], [""]);
      csvData.push(["Productivity Indices (%)", this.years]);
      csvData.push([""], [""], [""], [""], [""]);
      csvData.push(["Startup Activity and Performance"]);
      csvData.push(["", this.years]);
      this.filtered_startup_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], [""], [""]);
      csvData.push(
          [
            "To enhance report load times Concentration values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser",
          ],
          [""],
          [""],
          [""],
          [""],
          [this.cessationLabel]
      );
      this.filtered_cessation_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], ["Ownership/Consolidation Trends", this.years]);
      this.filtered_ownership_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([""], ["Market Area Demographic Highlights"]);
      csvData.push([
        "(based on zip codes co-joined with your market radius) (2015)",
      ]);
      this.filtered_demographic_info.forEach((element, index) => {
        element.forEach((el, i) => {
          csvData.push(el);
        });
        csvData.push([""]);
      });
      return csvData;
    },
    parseCSVData() {
      this.tableDataMarketVolume = Object.entries(this.marketVolume).map(
          ([table, data]) => ({
            name: table,
            dates: Object.values(data),
          })
      );
      this.tableDataMarketShare = Object.entries(this.marketShare).map(
          ([table, data]) => ({
            name: table,
            dates: Object.values(data),
          })
      );
      let me = this;
      this.tableDataMarketVolume.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithCommas(e);
        });
        return item;
      });
      let modifiedArr = [];
      this.tableDataMarketVolume.forEach((element) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((element) => {
          r.push(element);
        });
        r.unshift(element.name);
        modifiedArr.push(r);
      });
      modifiedArr.forEach((el) => {
        let modified = el.map(function (el) {
          if (typeof el === "string" && el.includes(",")) {
            return el.replace(/,/g, ".");
          }
          return el;
        });
        this.filtered_market_volume.push(modified);
      });
      this.tableDataMarketShare.forEach((element) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((element) => {
          r.push(element);
        });
        r.unshift(element.name);
        this.filtered_market_share.push(r);
      });
      this.filtered_market_share = this.filtered_market_share.filter(
          (item, index) => {
            return !item.includes("Your Firm");
          }
      );
      let populationData = Object.entries(this.tableCompetitors).map(
          ([table, data]) => ({
            name: table,
            dates: Object.values(data),
          })
      );
      populationData.forEach((element) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((element) => {
          r.push(element);
        });
        r.unshift(element.name);
        this.filtered_population.push(r);
      });
      let tableAnnual = Object.entries(this.annualSales).map(
          ([table, data]) => ({
            name: table,
            dates: Object.values(data),
          })
      );
      tableAnnual.forEach((element) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((element) => {
          r.push(element);
        });
        r.unshift(element.name);
        this.filtered_annual_sales.push(r);
      });
      this.filtered_annual_sales = this.filtered_annual_sales.filter(
          (item, index) => {
            if (!item.includes("Your Firm")) {
              return item;
            }
          }
      );
      let penetrationData = Object.entries(this.penetration).map(
          ([table, data]) => ({
            name: table,
            dates: Object.values(data),
          })
      );
      penetrationData.map((item) => {
        item.dates = item.dates.map((e) => {
          return me.numberWithPoints(e);
        });
        return item;
      });
      penetrationData.forEach((element) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((element) => {
          r.push(element);
        });
        r.unshift(element.name);
        this.filtered_penetration.push(r);
      });
      let employmentData = Object.entries(this.employment).map(
          ([table, data]) => ({
            name: table,
            dates: Object.values(data),
          })
      );
      employmentData.forEach((element) => {
        let v = Object.values(element.dates);
        let r = [];
        v.forEach((element) => {
          r.push(element);
        });
        r.unshift(element.name);
        this.filtered_employment.push(r);
      });
      this.filtered_employment = this.filtered_employment.filter(
          (item, index) => {
            return !item.includes("Your Firm");
          }
      );
      if (this.salesEmpSales) {
        let marketVolumeByClass = Object.entries(
            this.salesEmpSales.marketVolume
        ).map(([name, data]) => ({
          name,
          dates: data,
        }));
        this.salesEmpCols.forEach((element, index) => {
          let b = [];
          marketVolumeByClass.forEach((el, num) => {
            b.push(el.dates[index]);
          });
          b.unshift(element);
          this.filtered_market_by_class.push(b);
        });
        let marketPercentVolumeByClass = Object.entries(
            this.salesEmpSales.percentMarket
        ).map(([name, data]) => ({
          name,
          dates: data,
        }));
        this.salesEmpCols.forEach((element, index) => {
          let b = [];
          marketPercentVolumeByClass.forEach((el, num) => {
            b.push(el.dates[index]);
          });
          b.unshift(element);
          this.filtered_market_percent_by_class.push(b);
        });
      }
      if (this.salesEmpEmployment) {
        let averageSaleByClass = Object.entries(
            this.salesEmpEmployment.average
        ).map(([name, data]) => ({
          name,
          dates: data,
        }));
        this.salesEmpCols.forEach((element, index) => {
          let b = [];
          averageSaleByClass.forEach((el, num) => {
            b.push(el.dates[index]);
          });
          b.unshift(element);
          this.filtered_average_sale_by_class.push(b);
        });
        let establishmentByClass = Object.entries(
            this.salesEmpEmployment.establishments
        ).map(([name, data]) => ({
          name,
          dates: data,
        }));
        this.salesEmpCols.forEach((element, index) => {
          let b = [];
          establishmentByClass.forEach((el, num) => {
            b.push(el.dates[index]);
          });
          b.unshift(element);
          this.filtered_establishment_by_class.push(b);
        });
        let totalEmploymentByClass = Object.entries(
            this.salesEmpEmployment.total
        ).map(([name, data]) => ({
          name,
          dates: data,
        }));
        this.salesEmpCols.forEach((element, index) => {
          let b = [];
          totalEmploymentByClass.forEach((el, num) => {
            b.push(el.dates[index]);
          });
          b.unshift(element);
          this.filtered_total_employment_by_class.push(b);
        });
        let averageEmploymentByClass = Object.entries(
            this.salesEmpEmployment.average
        ).map(([name, data]) => ({
          name,
          dates: data,
        }));
        this.salesEmpCols.forEach((element, index) => {
          let b = [];
          averageEmploymentByClass.forEach((el, num) => {
            b.push(el.dates[index]);
          });
          b.unshift(element);
          this.filtered_average_employment_by_class.push(b);
        });
      }
      if (this.productivity) {
        let annualSalesPerEmployee = Object.entries(
            this.productivity.spe
        ).map(([name, data]) => ({name, dates: data}));
        annualSalesPerEmployee.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithPoints(e);
          });
          return item;
        });
        annualSalesPerEmployee.forEach((element, index) => {
          let v = Object.values(element.dates);
          let r = [];
          v.forEach((el) => {
            r.push(el);
          });
          r.unshift(element.name);
          this.filtered_annual_sales_per_employee.push(r);
        });
        this.filtered_annual_sales_per_employee = this.filtered_annual_sales_per_employee.filter(
            (item, index) => {
              return !item.includes("Your Firm");
            }
        );
      }
      if (this.productivity) {
        let averageAnnualWage = Object.entries(
            this.productivity.annualWage
        ).map(([name, data]) => ({name, dates: data}));
        averageAnnualWage.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithPoints(e);
          });
          return item;
        });
        averageAnnualWage.forEach((element, index) => {
          let v = Object.values(element.dates);
          let r = [];
          v.forEach((el) => {
            r.push(el);
          });
          r.unshift(element.name);
          this.filtered_average_annual_wage.push(r);
        });
        this.filtered_average_annual_wage = this.filtered_average_annual_wage.filter(
            (item, index) => {
              return !item.includes("Your Firm");
            }
        );
      }
      if (this.productivity) {
        let rentPerEmployee = Object.entries(
            this.productivity.rent
        ).map(([name, data]) => ({name, dates: data}));
        rentPerEmployee.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithPoints(e);
          });
          return item;
        });
        rentPerEmployee.forEach((element, index) => {
          let v = Object.values(element.dates);
          let r = [];
          v.forEach((el) => {
            r.push(el);
          });
          r.unshift(element.name);
          this.filtered_rent_per_employee.push(r);
        });
        this.filtered_rent_per_employee = this.filtered_rent_per_employee.filter(
            (item, index) => {
              return !item.includes("Your Firm");
            }
        );
      }
      if (this.startupPerformance) {
        let startupPerformance = Object.entries(this.startupPerformance).map(
            ([table, data]) => ({
              name: table,
              dates: Object.values(data),
            })
        );
        startupPerformance.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithPoints(e);
          });
          return item;
        });
        startupPerformance.forEach((element, index) => {
          let v = Object.values(element.dates);
          let r = [];
          v.forEach((el) => {
            r.push(el);
          });
          r.unshift(element.name);
          this.filtered_startup_info.push(r);
        });
        let startupRates = Object.entries(this.startupRates).map(
            ([table, data]) => ({
              name: table,
              dates: Object.values(data),
            })
        );
        startupRates.map((item) => {
          item.dates = item.dates.map((e) => {
            return me.numberWithPoints(e);
          });
          return item;
        });
        startupRates.forEach((element, index) => {
          let v = Object.values(element.dates);
          let r = [];
          v.forEach((el) => {
            r.push(el);
          });
          r.unshift(element.name);
          this.filtered_startup_info.push(r);
        });
      }
      if (this.cessation) {
        let cessationRates = Object.entries(this.cessation).map(
            ([table, data]) => ({
              name: table,
              dates: Object.values(data),
            })
        );
        cessationRates.forEach((element, index) => {
          let v = Object.values(element.dates);
          let r = [];
          v.forEach((el) => {
            r.push(el);
          });
          r.unshift(element.name);
          this.filtered_cessation_info.push(r);
        });
        let ownerShip = Object.entries(this.ownership).map(([table, data]) => ({
          name: table,
          dates: Object.values(data),
        }));
        ownerShip.forEach((element, index) => {
          let v = Object.values(element.dates);
          let r = [];
          v.forEach((el) => {
            r.push(el);
          });
          r.unshift(element.name);
          this.filtered_ownership_info.push(r);
        });
      }
      if (this.demographics) {
        let demographicInfo = Object.entries(this.demographics).map(
            ([table, data]) => ({
              name: table,
              data: Object.values(data),
            })
        );
        demographicInfo.forEach((element, index) => {
          this.filtered_demographic_info[index] = [];
          this.filtered_demographic_info[index].push([element.name]);
          element.data.forEach((el, i) => {
            Object.keys(el).forEach((key) => {
              let a = el[key];
              a = a.map((e) => {
                if (typeof e === "string" && e.includes(",")) {
                  return me.numberWithPoints(e);
                } else {
                  return e;
                }
              });
              if (!a.includes(key)) {
                a.unshift(key);
              }
              this.filtered_demographic_info[index].push(a);
            });
          });
        });
      }
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return x;
      }
    },
    numberWithPoints(x) {
      if (typeof x === "number") {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else if (typeof x === "string") {
        return x.replace(/,/g, ".");
      } else {
        return x;
      }
    },
    async downloadCSVData() {
      this.$store.commit("user/SET_CSV_LOADING", true);
      let csv = "";
      let csvData = await this.getCSVData();
      csvData.forEach((row) => {
        csv += row.join(",");
        csv += "\n";
      });
      const anchor = document.createElement("a");
      anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
      anchor.target = "_blank";
      anchor.download = "Industry Market Profile.csv";
      anchor.click();
      this.$store.commit("user/SET_CSV_LOADING", false);
      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: "CSV",
      });
    },
  },
  mounted() {
    this.$store.commit("user/SET_PDF_LOADING", false);
    this.parseCSVData();
  },
};
</script>
